import React from 'react'
import { oneOf, string, node } from 'prop-types'
import { getClassList } from './helpers'

const DataTd = ({ multiCol, multiRow, className, children, ...rest }) => (
  <td className={ getClassList({ multiRow, multiCol, className }) } { ...rest }>
    {children}
  </td>
)

DataTd.defaultProps = {
  multiCol: false,
  multiRow: false,
}

DataTd.propTypes = {
  multiCol: oneOf(['start', 'end', true, false]),
  multiRow: oneOf(['start', 'end', true, false]),
  className: string,
  children: node.isRequired,
}

export default DataTd
